module.exports = __webpack_public_path__ + "img/security-payment.65022f4f.png";